<template>
  <div
    v-show="isVisible"
    class="bubble-container">
    <div
      v-if="user"
      class="user-info">
      <el-image
        :src="user.picture_thumbnail_url || 'https://maprochaineauto-public-s3.s3.eu-west-3.amazonaws.com/profile-pictures/default_thumbnail.jpg'"
        alt="Véhicule"
        fit="cover" />
      <span>Vous discutez désormais avec</span>
      <strong>{{ user.firstname }} {{ user.lastname }}</strong>
    </div>

    <div
      class="bubble"
      :class="bubbleClasses"
      @click="handleClick">
      <WaveDotsLoader v-if="isTyping" />

      <template v-else>
        <strong>
          {{ content || '' }}
        </strong>
        <el-button
          v-if="isEditable"
          type="text"
          icon="el-icon-refresh-left" />
      </template>
    </div>
  </div>
</template>

<script>
import ChatError from "@/chatbot-library/ChatError"
import WaveDotsLoader from "./WaveDotsLoader"

export default {
  name: "Bubble",
  components: { WaveDotsLoader },
  props: {
    data: {
      type: [Promise, String],
      required: true
    },
    isUser: {
      type: Boolean,
      default: false
    },
    delay: {
      type: Number,
      default: null
    },
    isEditable: {
      type: Boolean,
      default: false
    },
    isLarge: {
      type: Boolean,
      default: false
    },
    user: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      isTyping: false,
      isVisible: true,
      content: null
    }
  },
  computed: {
    bubbleClasses() {
      let classes = {
        "is-editable": this.isEditable,
        "is-large": this.isLarge
      }

      classes["bubble__" + (this.isUser ? "user" : "rodger")] = true
      return classes
    }
  },
  mounted() {
    this.initBubble(Promise.resolve(this.data), this.delay)
  },
  methods: {
    initBubble(content, delay = null) {
      this.isTyping = true
      let start = new Date().getTime()

      content
        .then(response => [response, false])
        .catch(error => {
          window.console.error(error)
          let response = error instanceof ChatError
            ? error.content
            : "Une erreur est survenue."
          return [response, true]
        })
        .then(([content, error]) => {
          if (!content) {
            this.isVisible = false
          }

          this.content = content

          let ellapsed = new Date().getTime() - start
          let timeout = Math.max((delay !== null ? delay : Math.min(content.length * 60, 3500)) - ellapsed, 0)
          setTimeout(() => {
            this.isTyping = false
            this.$emit(error ? "error" : "ready")
          }, timeout)
        })
    },
    handleClick() {
      if (this.isEditable) {
        this.$emit("select")
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.bubble-container {
  display: flex;
  flex-direction: column;

  .user-info {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: 12px 0;

    .el-image {
      width: 48px;
      height: 48px;
      object-fit: contain;
      border-radius: 50%;
      border: 1px solid color(gray05);
      margin-bottom: 6px;
    }

    &::before {
      content: "";
      position: absolute;
      height: 1px;
      width: 70%;
      background-color: color(gray05);
      top: 24px;
    }
  }

  .bubble {
    position: relative;
    max-width: 90%;
    padding: 12px 24px;
    font-size: 13px;
    line-height: 20px;
    color: color(plainWhite);
    white-space: pre-line;

    @include device(tablet) {
      max-width: 70%;
    }

    &__user {
      box-shadow: -14px 2px 22px -9px color(gray04);
      border-radius: 40px 40px 4px 40px;
      background-color: color(deepSeaBlue);
      margin-left: auto;
    }

    &__rodger {
      border-radius: 40px 40px 40px 4px;
      background-color: color(paperWhite);
      margin-right: auto;
      color: color(gray01);
    }

    .wave-dot {
      height: 24px;
      line-height: 24px;
    }

    .el-button {
      padding: 0;
      height: 100%;
      font-weight: 500;
      color: color(plainWhite);
      margin-left: 10px;
      transition: transform 0.8s ease;

      i {
        font-weight: 500;
      }
    }

    &.is-editable {
      padding-right: 14px;
      cursor: pointer;

      &:hover .el-button {
        transform: rotate(-360deg);
      }
    }

    &.is-large {
      font-size: 14px;
      line-height: 24px;
    }
  }
}
</style>
